<template>
  <div class="Identity">
    <div class="input_box">
      <Input
          v-model="col"
          :params="propsVal"
          :errorMessage="errorMessage"
          :allowClearHandler="allowClearHandler"
          :form="form"
        />
    </div>
  </div>
</template>

<script>
import Input from '@/components/Input/index.vue';

export default {
  name: 'Identity',
  props: ['params', 'errorMessage', 'allowClearHandler', 'form'],
  data() {
    return {
      col: '',
      isDelete: false,
      message: {
        field: 'loanAmount',
        message: '',
      },
      propsVal: {},
    };
  },
  components: {
    Input,
  },
  watch: {
    col: {
      handler(newVal) {
        this.handleinput();
      },
      immediate: true,
    },
  },
  methods: {

  },
};
</script>
<style scoped>
.Identity{
  background: #fff;
  padding-right: 16px;
}
.input_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.input_box .inputShell{
  flex: 1;
}

</style>
